import { Select } from 'evergreen-ui';
import React from 'react';
import { getDisabledSelect, getNotSelectedValueLabel } from './utils';
import {useGetStationTypesQuery} from "../../Services/api/stationTypesApi";

export type CategoryType = {
  enabled: boolean,
  id: number,
  name: string,
  vocStationCat: {
    enabled: boolean,
    id: number,
    kto: string,
    name: string
  }
}

export type CategoryTypeSelectProps = {
  isLoading?: boolean,
  selected: number | undefined | null,
  onSelect?: (selectedId: number | undefined) => void,
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void,
}

// TODO: сделать все также как и в RegionSelect
export function CategoryTypeSelect({
  selected,
  onSelect,
  onChange,
}: CategoryTypeSelectProps) {
  /*
  Есть также все типы по ресту: /stationtypes
  Есть категории, который также могут иметь список типов ресть: /stationcats
  */
  const { data, isLoading } = useGetStationTypesQuery(undefined);
  const types = (data || []) as CategoryType[]

  const { disabledSelect, notSelectedValueLabel } = React.useMemo(() => {
    return {
      notSelectedValueLabel: getNotSelectedValueLabel({
        isLoading,
        dataLength: types.length,
        label: 'ВСЕ ТИПЫ',
        noDataLabel: 'Нет типов'
      }),
      disabledSelect: getDisabledSelect({
        isLoading, dataLength:
        types.length
      }),
    };
  }, [isLoading]);

  const onChangeType = React.useCallback((event:React.ChangeEvent<HTMLSelectElement>) => {
    const selected = event.target.value;
    if (selected === '-1') {
      onSelect && onSelect(undefined);
    } else {
      onSelect && onSelect(Number(selected));
    }
    onChange && onChange(event);
  }, []);

  return (
      <Select value={selected ?? -1} onChange={onChangeType} disabled={disabledSelect}>
        <option value={-1}>{notSelectedValueLabel}</option>
        {
          types?.map(({ id, name}) => {
            return (
                <React.Fragment key={id}>
                  <option value={id}>{name}</option>
                </React.Fragment>
            );
          })
        }
      </Select>
  );
}
export const MemoCategoryTypeSelect = React.memo(CategoryTypeSelect);
MemoCategoryTypeSelect.displayName = 'MemoCategoryTypeSelect';
export default CategoryTypeSelect;
